export function convertStyleProps(props, handlers) {
  let style = {};
  Object.keys(props).forEach(key => {
    let styleProp = handlers[key];

    if (!styleProp || props[key] == null) {
      return;
    }

    let [name, convert] = styleProp;

    if (typeof name === 'function') {
      name = name(key);
    }

    let value = convert(props[key]);

    if (Array.isArray(name)) {
      for (let k of name) {
        style[k] = value;
      }
    } else {
      style[name] = value;
    }
  });
  return style;
}